import { ReactElement } from 'react';
import { Button, Menu, MenuPopover, MenuTrigger, PositioningShorthand, makeStyles } from '@fluentui/react-components';

type Props = {
  children: ReactElement<any>;
  onConfirm: () => void;
  positioning?: PositioningShorthand;
  warningText?: string;
};

const useStyles = makeStyles({
  button: {
    minWidth: 0,
  },
});

const ConfirmMenu = ({ children, onConfirm, positioning, warningText = 'Are you sure?' }: Props) => {
  const classes = useStyles();
  return (
    <Menu positioning={positioning}>
      <MenuTrigger>{children}</MenuTrigger>

      <MenuPopover>
        <div className="flex space-x-2 items-center px-2 py-1">
          <p>{warningText}</p>
          <div>
            <Button appearance="primary" onClick={onConfirm} className={classes.button}>
              Yes
            </Button>
          </div>
        </div>
      </MenuPopover>
    </Menu>
  );
};

export { ConfirmMenu };
